import { useState } from "react";
import "./Contact.scss";
import { useRef } from "react";
import { useInView, motion } from "framer-motion";
import { toast } from "react-toastify";
import emailjs from "@emailjs/browser";
import backgroundImage from "../../Assets/images/img12.jpg";

const ContactPage = () => {
  const titleRef = useRef(null);
  const isInView = useInView(titleRef, {
    once: true,
    amount: 0.1,
  });

  const [buttonState, setButtonState] = useState("idle");
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    address: "",
    message: "",
    attachment: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Send email using EmailJS
  const sendEmail = (e) => {
    e.preventDefault();
    setButtonState("sending");

    const templateParams = {
      name: formData.name,
      email: formData.email,
      phone: formData.phone,
      address: formData.address,
      message: formData.message,
      attachment: formData.attachment,
    };

    emailjs
      .send(
        "service_khbiewg",
        "template_ij318fn",
        templateParams,
        "R2tM80-RRrKtndFJu"
      )
      .then((response) => {
        console.log("Email sent successfully!", response);
        toast.success("Message Sent Successfully!");
        setButtonState("sent");

        // Reset form and button state after 2.5s
        setTimeout(() => {
          setButtonState("idle");
          setFormData({
            name: "",
            email: "",
            phone: "",
            address: "",
            message: "",
            attachment: "",
          });
        }, 2500);
      })
      .catch((error) => {
        console.log("Failed to send email.", error);
        toast.error("Failed to send message, try again!");
        setButtonState("idle");
      });
  };

  return (
    <section className="contact-page">
      <div
        className="portfolio-banner"
        style={{ backgroundImage: `url(${backgroundImage})` }}
      >
        <div className="portfolio-overlay" />
        <div className="portfolio-text container text-left">
          <motion.div
            ref={titleRef}
            initial={{ opacity: 0, y: 100 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.99, ease: "easeOut", delay: 0.2 }}
          >
            <h5>CONTACT US</h5>
          </motion.div>
        </div>
      </div>

      <div className="white-container">
        <div className="inner-container"></div>
      </div>

      {/* Contact Content */}
      <div className="container">
        <div className="row justify-content-center">
          {/* Steps Section */}
          <div className="col-lg-5 col-md-12 steps-section">
            <div className="map-container">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14129.360227896104!2d85.33366!3d27.706785!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39eb194eb0dd4203%3A0x9f9d486a258772a7!2sARON%20Engineering%20Pvt.%20Ltd.!5e0!3m2!1sen!2snp!4v1698564257439!5m2!1sen!2snp"
                width="600"
                height="450"
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>

          {/* Contact Form Section */}
          <div className="col-lg-6 col-md-12 contact-form-container">
            <form className="contact-form" onSubmit={sendEmail}>
              <div className="contact-top">
                <h4 style={{ textAlign: "justify" }}>Leave a message</h4>
              </div>

              <div className="row">
                <div className="col-12">
                  <input
                    type="text"
                    name="name"
                    placeholder="Your Name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-12">
                  <input
                    type="email"
                    name="email"
                    placeholder="Your Email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-md-6">
                  <input
                    type="tel"
                    name="phone"
                    placeholder="Phone"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="col-md-6">
                  <input
                    type="text"
                    name="address"
                    placeholder="Project Address"
                    value={formData.address}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

              <textarea
                name="message"
                placeholder="Message"
                value={formData.message}
                onChange={handleChange}
                required
              ></textarea>

              <button className={`send-button ${buttonState}`}>
                <span className="txt">submit</span>
                <span className="txt2">sent!</span>
                <span className="loader-container">
                  <span className="loader"></span>
                </span>
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactPage;
